import { Typography } from '@mui/material';
import { styled } from '@mui/system';

export const StyledErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '11px',
  marginTop: '8px',
  lineHeight: '13.86px',
}));
